// imageUtils.js
export function convertSVGToDataURL(svgText, width, height) {
  return new Promise((resolve, reject) => {
    try {
      const svgBlob = new Blob([svgText], {
        type: "image/svg+xml;charset=utf-8",
      });
      const url = URL.createObjectURL(svgBlob);

      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        const dataURL = canvas.toDataURL("image/png");
        URL.revokeObjectURL(url);
        resolve(dataURL);
      };
      img.onerror = reject;
      img.src = url;
    } catch (error) {
      reject(error);
    }
  });
}
